import React, { useState, useEffect } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { FiMenu, FiX, FiPhoneCall, FiChevronDown } from "react-icons/fi";
import "./Navbar.css";
import { API_BASE } from "../config";



const Navbar = () => {
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);
  const [sticky, setSticky] = useState(false);
  const [categoryOpen, setCategoryOpen] = useState(false);
  const [categoryList, setCategoryList] = useState([]);

  useEffect(() => {
    const handleScroll = () => {
      setSticky(window.scrollY > 50);
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  useEffect(() => {
    fetch(`${API_BASE}?module=category`)
      .then((res) => res.json())
      .then((data) => {
        if (data.success && Array.isArray(data.categories) && data.categories.length > 0) {
          setCategoryList(
            data.categories.map((cat) => ({ name: cat.name, slug: cat.slug }))
          );
        }
      })
      .catch((err) => {
        console.error("Category fetch error:", err);
        setCategoryList([]);
      });
  }, []);

  const closeAll = () => {
    setMenuOpen(false);
    setCategoryOpen(false);
  };

  return (
    <header className={sticky ? "navbar sticky" : "navbar"}>
      <div className="nav-container">

        {/* Logo */}
        <NavLink to="/" className="logo" onClick={closeAll}>
          <span>⚡</span> Savariya Cable
        </NavLink>

        {/* Navigation */}
        <nav className={menuOpen ? "nav-links active" : "nav-links"}>

          <NavLink to="/" onClick={closeAll}>
            Home
          </NavLink>

          <NavLink to="/about" onClick={closeAll}>
            About
          </NavLink>

          {/* Category Dropdown */}
          <div
            className="nav-dropdown"
            onMouseEnter={() => setCategoryOpen(true)}
            onMouseLeave={() => setCategoryOpen(false)}
          >
            <div
              className="dropdown-trigger"
              onClick={() => setCategoryOpen(!categoryOpen)}
            >
              <NavLink to="/categories" onClick={closeAll}>
                Category
              </NavLink>
              <FiChevronDown
                className={categoryOpen ? "chevron rotate" : "chevron"}
              />
            </div>

            <div className={categoryOpen ? "dropdown-menu open" : "dropdown-menu"}>
              {categoryList.map((item) => (
                <NavLink
                  key={item.slug}
                  to={`/categories/${item.slug}`}
                  onClick={closeAll}
                >
                  {item.name}
                </NavLink>
              ))}
            </div>
          </div>

          <NavLink to="/gallery" onClick={closeAll}>
            Gallery
          </NavLink>

          <NavLink to="/blogs" onClick={closeAll}>
            Blogs
          </NavLink>

          <NavLink to="/contact" onClick={closeAll}>
            Contact
          </NavLink>

        </nav>

        {/* Right Side */}
        <div className="nav-right">
          <a href="tel:+919876543210" className="call-btn">
            <FiPhoneCall />
            <span>Call Now</span>
          </a>
        </div>

        {/* Mobile Menu */}
        <div className="menu-icon" onClick={() => setMenuOpen(!menuOpen)}>
          {menuOpen ? <FiX /> : <FiMenu />}
        </div>

      </div>
    </header>
  );
};

export default Navbar;